import { unwrapConnection } from "@utils/utils";

import { ReportSectionsType } from "@api/graphql/types-and-hooks";
import { useIsReportCompleted, useIsReviewPage } from "@components/ReportField/capabilities/flags";

// Whether "Regenerate" shows. Reproduces the legacy Assessment V2
// SectionWidgetWrapper gating: any field is AI-generated, sourced from a
// prompt, or has an input dependency — independent of handlebars export.
export const useCanRegenerateSection = (section: ReportSectionsType): boolean => {
  const isReviewPage = useIsReviewPage();
  const isCompleted = useIsReportCompleted();

  const hasRegenerableField = (unwrapConnection(section.sectionField) ?? []).some(
    (sf) =>
      sf?.aiGenerated ||
      sf?.aiSectionField?.templateSectionField?.prompt?.id ||
      (sf?.templateSectionField?.inputDependency && sf.templateSectionField.inputDependency.length > 0),
  );

  return hasRegenerableField && !isReviewPage && !isCompleted;
};
